var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6504 0.254883C16.0329 -0.0851173 16.5858 -0.0851173 16.9258 0.254883L20.2402 3.57031C20.4101 3.74021 20.496 3.95224 20.4961 4.20703C20.4961 4.46203 20.4102 4.6752 20.2402 4.8877L5.70605 19.4229C5.57858 19.5503 5.40825 19.6352 5.23828 19.6777L1.07324 20.5273H0.90332C0.64832 20.5273 0.435625 20.4425 0.265625 20.2725C0.0531404 20.06 -0.0317564 19.7623 0.0107422 19.4648L0.860352 15.2998C0.902862 15.1298 0.987765 14.9595 1.11523 14.832L13.1436 2.7627L15.6504 0.254883ZM2.56055 15.8945L2.00781 18.4453L4.60059 17.9346L15.8203 6.71484L13.7803 4.6748L2.56055 15.8945ZM15.0557 3.44238L17.0957 5.48242L18.3711 4.20703L16.3311 2.16797L15.0557 3.44238Z",
    fill: "#626161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6504 0.254883C16.0329 -0.0851173 16.5858 -0.0851173 16.9258 0.254883L20.2402 3.57031C20.4101 3.74021 20.496 3.95224 20.4961 4.20703C20.4961 4.46203 20.4102 4.6752 20.2402 4.8877L5.70605 19.4229C5.57858 19.5503 5.40825 19.6352 5.23828 19.6777L1.07324 20.5273H0.90332C0.64832 20.5273 0.435625 20.4425 0.265625 20.2725C0.0531404 20.06 -0.0317564 19.7623 0.0107422 19.4648L0.860352 15.2998C0.902862 15.1298 0.987765 14.9595 1.11523 14.832L13.1436 2.7627L15.6504 0.254883ZM2.56055 15.8945L2.00781 18.4453L4.60059 17.9346L15.8203 6.71484L13.7803 4.6748L2.56055 15.8945ZM15.0557 3.44238L17.0957 5.48242L18.3711 4.20703L16.3311 2.16797L15.0557 3.44238Z",
    stroke: "#E2DBDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.b704662cbfcbeed881376b723ec20ec1.svg";
export { ForwardRef as ReactComponent };